// This file is meant to mimic "DismissableBanner/styles.ts" in the customers codebase

import { colors, spacing } from 'ic-snacks'
import { css } from '@emotion/react'

export const baseContainerStyle = (mobile, bgColorOverride = null) =>
  css({
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'space-around',
    backgroundColor: bgColorOverride || colors.WHITE,
    maxHeight: '300px',
    overflow: 'hidden',
    ...spacing.MARGIN_XS,
    ...(mobile && {
      maxHeight: '200px',
    }),
  })

export default {
  clickableRegion: css({
    display: 'flex',
    width: '100%',

    ':focus': {
      textDecoration: 'none',
    },
    ':hover': {
      textDecoration: 'none',
    },
  }),
  textContainer: mobile =>
    css({
      ...spacing.PADDING_LG,
      ...spacing.MARGIN_LEFT_SM,
      width: '50%',
      flex: '3 3 0',
      ...(mobile && {
        ...spacing.PADDING_SM,
        marginLeft: 0,
        flex: '1 2 0',
      }),
    }),
  textModule: mobile =>
    css({
      height: '100%',
      display: 'flex',
      flexDirection: 'column' as const,
      maxWidth: 500,
      ...(mobile && {
        maxWidth: 250,
      }),
    }),
  textAnnouncement: mobile =>
    css({
      ...spacing.PADDING_Y_XS,
      text: 'uppercase',
      fontSize: 14,
      ...(mobile && {
        fontSize: 11,
        ...spacing.PADDING_BOTTOM_XS,
        paddingTop: 0,
      }),
    }),
  textHeading: mobile =>
    css({
      fontSize: 36,
      lineHeight: '44px',
      fontWeight: 600,
      margin: 0,
      ...(mobile && {
        fontSize: 18,
        ...spacing.MARGIN_BOTTOM_XS,
        lineHeight: '24px',
      }),
    }),
  textSubHeading: mobile =>
    css({
      ...spacing.PADDING_Y_XS,
      ...spacing.MARGIN_BOTTOM_SM,
      paddingRight: 4,
      fontSize: 18,
      ...(mobile && {
        display: 'none',
      }),
    }),
  imageContainer: mobile =>
    css({
      width: '100%',
      flex: '3 3 0',
      padding: 0,
      ...(mobile && {
        flex: '1 1 0',
        alignSelf: 'center',
        margin: '0 auto',
      }),
    }),
  textVariantImageContainer: css({
    width: '50%',
    objectFit: 'cover',
  }),
  icon: mobile =>
    css({
      top: 0,
      right: 0,
      color: colors.GRAY_20,
      cursor: 'pointer',
      height: 24,
      width: 24,
      ...(mobile && {
        height: 16,
        width: 16,
      }),
    }),
  svg: css({
    width: '100%',
    height: '100%',
  }),
}
